// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__QpiQ-","dragIcon":"SortableItem_dragIcon__3-xXz","disabled":"SortableItem_disabled__2dOlw"};